import React, { Component } from 'react';
import compose from 'lodash/flowRight';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';

class Landing extends Component {
  state = {};

  render() {
    // For now, don't show landing page. Redirect to either the sessions page, or login page.
    const toRoute = this.props.isAuthenticated ? this.props.defaultAuthenticatedRoute : '/login';

    return <Redirect to={toRoute} />;
  }
}

const mapState = (state) => ({
  isAuthenticated: state.user.isAuthenticated,
});

export default compose(connect(mapState))(Landing);
